import { render, staticRenderFns } from "./VButtonIcon.vue?vue&type=template&id=7d3f216b&"
import script from "./VButtonIcon.vue?vue&type=script&lang=js&"
export * from "./VButtonIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports